import { Injectable } from '@angular/core'
import {
  RootState,
  setReconDate,
  setUserPolicy,
} from '@helios/state-management'
import { Store } from '@ngrx/store'
import { HttpSessionsService } from '../http-sessions-service/http-sessions.service'
import { HttpUserService } from '../http-user-service/http-user.service'

@Injectable({
  providedIn: 'root',
})
export class SessionsAppInitializerService {
  constructor(
    private readonly httpSessionsService: HttpSessionsService,
    private readonly httpUserService: HttpUserService,
    private readonly store: Store<RootState>,
  ) {}

  init(): void {
    this.httpSessionsService.getReconDate().then(date => {
      this.store.dispatch(setReconDate({ reconDate: date }))
    })

    this.httpUserService.getUserPolicy().then(policy => {
      this.store.dispatch(setUserPolicy({ userPolicy: policy }))
    })
  }
}
